import Hero from 'components/Hero';
import PublicGoods from 'components/PublicGoods';

const Home = () => {
  return (
    <main>
      <Hero />
      <PublicGoods />
    </main>
  );
};

export default Home;
